<template v-slot:append>
  <v-dialog max-width="95%" persistent no-click-animation
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="showDialog">
    <v-card min-height="75%" min-width="95%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          貨物紐付け可能日報検索
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-expansion-panels v-model="expansionPanel" multiple flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row ref="_calcHeight-Row1">
                  <v-col :cols="12">
                    <dd-sub-header>
                      検索条件
                    </dd-sub-header>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row no-gutters align-content="center" ref="_calcHeight-Row2">
                   <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="営業所コード/名称"
                          v-model="conditions.eigyoshoCd"
                          ref="eigyoshoCd"
                          :required=false
                          :length=100
                          :valueType="ctypes.InputTypes.Free"
                          :itemList="filteredEigyoshoList"
                          titleText="営業所検索"
                          item-value="eigyoshoCd"
                          item-text="eigyoshoNm"
                          :headerList="mstEigyoshoHeader"
                          />
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <div style="width:48%" class="px-1">
                        <dd-date-box
                          label="日報日"
                          v-model="conditions.nippoYmdFrom"
                          ref="nippoYmdFrom"
                          :readonly="false"
                          />
                      </div>
                      <div style="width:4%" class="mt-2 mp-0">～</div>
                      <div style="width:48%" class="px-1">
                        <dd-date-box
                          v-model="conditions.nippoYmdTo"
                          ref="nippoYmdTo"
                          :readonly="false"
                          />
                      </div>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <v-radio-group
                          label="連絡事項"
                          v-model="conditions.renrakuJikoStatus"
                          row>
                          <dd-radio-button
                            label="全て"
                            value="99"
                          />
                          <dd-radio-button
                            label="なし"
                            value="02"
                          />
                          <dd-radio-button
                            label="あり"
                            value="03"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-text-box
                         label="連絡事項"
                         v-model="conditions.sagyoNaiyoBiko"
                         ref="sagyoNaiyoBiko"
                         :length="100"
                         :disabled="sagyoNaiyoBikoDisabled"
                         :valueType="Ctrls.InputTypes.Free"/>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters align-content="center" ref="_calcHeight-Row3">
                  <v-col :cols="9">
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-toolbar class="pa-0 ma-0" flat dense>
                        <v-spacer />
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onSearchButtonClick">
                          検索
                        </dd-default-button>
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onClearButtonClick">
                          クリア
                        </dd-default-button>
                      </v-toolbar>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row no-gutters align-content="center" ref="_calcHeight-Row4">
            <v-col :cols="6">
              <dd-sub-header>
                一覧
              </dd-sub-header>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="3">
              <dd-narrow-down-text-box v-model="searchText" :length=10 />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="検索結果"
                v-model="rowCount"/>
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="絞込結果"
                v-model="filteredRowCount"/>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center">
            <v-col :cols="12">
              <dd-data-table
                v-model="selectedItem"
                calculate-widths
                :height="calcHeightTable"
                item-key="id"
                showSelect
                @click:row="onRowClick"
                @dblclick:row="onRowDoubleClick"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                :header-props="{sortByText: '並び替え'}"
                :footer-props="{'items-per-page-options': [100, 200, 300, 400, 500],showFirstLastPage: true,}"
                loading-text="検索中のため、少々お待ちください。"
                :itemsPerPage=500
                fixed-header
                locale="ja-jp"
                no-data-text="利用可能なデータはありません。"
                dense
                :page.sync ="page"
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
         <dd-footer-button
           @click="onCloseClick">
           閉じる
         </dd-footer-button>
         <v-spacer></v-spacer>
         <dd-footer-button
           :disabled="isHimodukeButtonDisabled"
           @click="onHimodukeButtonClick">
           チェックした日報を紐付け
         </dd-footer-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import controls from '@/rahmen/controls'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'
import modals from '@/ddv2.library/modals'

import { mapGetters } from 'vuex'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdDateBox = () => import('@/components/DdDateBox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('@/components/DdTextBox')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdDataTable = () => import('@/components/DdDataTable')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')

export default {
  name: 'ThKamotsuHimodukeNippoSearchDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdDateBox,
    DdCodeTextBox,
    DdRadioButton,
    DdTextBox,
    DdDataTable,
    DdRowCountBox,
    DdDefaultButton,
    DdNarrowDownTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String
  },
  data: () => ({
    conditions: {
      eigyoshoCd: '',
      nippoYmdFrom: '',
      nippoYmdTo: '',
      renrakuJikoStatus: '',
      sagyoNaiyoBiko: ''
    },
    searchText: '',
    ctypes: controls,
    // 拡張パネル
    expansionPanel: [0, 1],
    /**
     * 一覧内容
     */
    rows: [],
    loading: false,
    selectedItem: [],
    page: 1
    /*
     *
     */
  }),
  created () {
    console.log('screen created')
    this.mstEigyoshoHeader = header.mstEigyoshoHeaders
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        if (elem.jissekiSagyoYmd) { elem.jissekiSagyoYmd = filter.dateFormatter(elem.jissekiSagyoYmd) }
        if (elem.jissekiShukkoYmd) { elem.jissekiShukkoYmd = filter.dateFormatter(elem.jissekiShukkoYmd) }
        if (elem.jissekiKikoYmd) { elem.jissekiKikoYmd = filter.dateFormatter(elem.jissekiKikoYmd) }

        return elem
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isHimodukeButtonDisabled () {
      return this.selectedItem.length === 0
    },
    sagyoNaiyoBikoDisabled () {
      if (this.conditions.renrakuJikoStatus === '03') {
        return false
      }
      return true
    },
    calcHeightTable () {
      if (this.expansionPanel.length === 1) {
        return this.tableHeight * 0.8
      }
      return this.tableHeight * 0.41
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('ThKamotsuHimodukeNippoSearchDialog.defineHeaderPromise')
            self.headers = [
              { text: 'ID', value: 'id', align: ' d-none' },
              { text: '日報日', value: 'jissekiSagyoYmd', align: 'center' },
              { text: '営業所', value: 'eigyoshoNm' },
              { text: '日報No', value: 'unkoJissekiNo' },
              { text: '車両プレート', value: 'sharyoPlateNo' },
              { text: '乗務員', value: 'jomuinNm' },
              { text: '傭車先名', value: 'hacchusakiNm' },
              { text: '出庫日', value: 'jissekiShukkoYmd', align: 'center' },
              { text: '帰庫日', value: 'jissekiKikoYmd', align: 'center' },
              { text: '連絡事項', value: 'sagyoNaiyoBiko' }]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          // ユーザ保存項目の復元
          this.conditions.eigyoshoCd = c.kamotsuHimodukeEigyoshoCd !== undefined && c.kamotsuHimodukeEigyoshoCd !== '' && c.kamotsuHimodukeEigyoshoCd !== null ? c.kamotsuHimodukeEigyoshoCd : ''
          this.conditions.nippoYmdFrom = c.kamotsuHimodukeNippoYmdFrom !== undefined && c.kamotsuHimodukeNippoYmdFrom !== '' && c.kamotsuHimodukeNippoYmdFrom !== null ? c.kamotsuHimodukeNippoYmdFrom : ''
          this.conditions.nippoYmdTo = c.kamotsuHimodukeNippoYmdTo !== undefined && c.kamotsuHimodukeNippoYmdTo !== '' && c.kamotsuHimodukeNippoYmdTo !== null ? c.kamotsuHimodukeNippoYmdTo : ''
          this.conditions.renrakuJikoStatus = c.kamotsuHimodukeRenrakuJikoStatus !== undefined && c.kamotsuHimodukeRenrakuJikoStatus !== '' && c.kamotsuHimodukeRenrakuJikoStatus !== null ? c.kamotsuHimodukeRenrakuJikoStatus : '99'
          this.conditions.sagyoNaiyoBiko = c.kamotsuHimodukeSagyoNaiyoBiko !== undefined && c.kamotsuHimodukeSagyoNaiyoBiko !== '' && c.kamotsuHimodukeSagyoNaiyoBiko !== null ? c.kamotsuHimodukeSagyoNaiyoBiko : ''

          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThKamotsuHimodukeNippoSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        settingViewScroll: () => {
          return true
        },
        researchPromise: (c) => {
          console.log('ThKamotsuHimodukeNippoSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('ThKamotsuHimodukeNippoSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThKamotsuHimodukeNippoSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      this.selectedItem = [f.item]
      if (this.selectedItem.length === 0) {
        this.$emit('close', undefined)
      } else {
        this.$emit('close', this.selectedItem)
      }
      // this.initBindVariables()
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
    },
    onRowClick: function (e) {
      /**
       * 選択処理
       * @event Click
       * @type {Event}
       */
      console.log('row clicked', e, this.searchText)
      this.selectedItem = [e]
      /*
      if (this.selectedItem.length === 0) {
        this.selectedItem = [e]
      } else {
        this.selectedItem = []
      }
      */
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCThrcod00104/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChacheById('THRCOD0010', cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            kamotsuHimodukeEigyoshoCd: self.conditions.eigyoshoCd ? self.conditions.eigyoshoCd : '',
            kamotsuHimodukeNippoYmdFrom: self.conditions.nippoYmdFrom ? self.conditions.nippoYmdFrom : '',
            kamotsuHimodukeNippoYmdTo: self.conditions.nippoYmdTo ? self.conditions.nippoYmdTo : '',
            kamotsuHimodukeRenrakuJikoStatus: self.conditions.renrakuJikoStatus,
            kamotsuHimodukeSagyoNaiyoBiko: self.conditions.sagyoNaiyoBiko ? self.conditions.sagyoNaiyoBiko : ''
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
        this.searchText = ''
        this.rows = []
        this.selectedItem = []
      })
      this.Effects.loadComplete()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', undefined)
      console.log('emited', this.showDialog)
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
      // this.clear(false)
    },
    onHimodukeButtonClick: function (e) {
      /**
       * 選択ボタン押下処理
       * @event click
       * @type {Event}
       */
      console.log('select clicked', e, this.selectedItem)
      if (this.selectedItem.length === 0) {
        this.$emit('close', undefined)
      } else {
        this.$emit('close', this.selectedItem)
      }
      // this.initBindVariables()
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
    },
    searchValidate: function () {
      var msg
      if (this.conditions.nippoYmdFrom && this.conditions.nippoYmdTo) {
        msg = validators.compareDate(this.conditions.nippoYmdFrom, this.conditions.nippoYmdTo)
        if (msg !== undefined) {
          this.$refs.nippoYmdFrom[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.nippoYmdTo[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        eigyoshoCd: '',
        nippoYmdFrom: '',
        nippoYmdTo: '',
        renrakuJikoStatus: '99',
        sagyoNaiyoBiko: ''
      }
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 400 !important;
}
</style>
